import React from 'react';

import Loading from '@src/components/ui2/Loading';
import { Sale } from '@src/core/buyerApiClient';
import { useAppSelector } from '@src/core/hooks';
import { currentSaleSelector } from '@src/stores/sale';
import SaleSummaryContent from './SaleSummaryContent';
import CurrencySelector from '../CurrencySelector';
import CurrencyWarning from '../CurrencyWarning';

interface DrawerProps {
  showTotal?: boolean;
  showPlaceholderImage?: boolean;
}

export const SaleSummary = (props: DrawerProps) => {
  const { showTotal = false, showPlaceholderImage = false } = props;

  const sale = useAppSelector(currentSaleSelector);

  const getSubTotal = (s: Sale) => (s.coupon ? s.coupon.fullAmountCurrencyInfo : s.partialAmountCurrencyInfo);

  return (
    <>
      <CurrencySelector />
      <CurrencyWarning />
      {sale ? (
        <SaleSummaryContent
          items={sale.items}
          subtotal={getSubTotal(sale)}
          coupon={sale.coupon}
          total={sale.totalAmountCurrencyInfo}
          showTotal={showTotal}
          showPlaceholderImage={showPlaceholderImage}
        />
      ) : (
        <Loading />
      )}
    </>
  );
};

export default SaleSummary;
